import type { LegacyTweetResponseType, MediaIncludeType } from '../types';

// Endpoint используется в виджете от Twitter
const TWITTER_CDN = 'https://cdn.syndication.twimg.com/tweet-result';

function getToken(id: string) {
  return ((Number(id) / 1e15) * Math.PI)
    .toString(6 ** 2)
    .replace(/(0+|\.)/g, '');
}

export function getRetweetMedia({
  currentRetweet,
  media
}: {
  currentRetweet: LegacyTweetResponseType | undefined;
  media: MediaIncludeType[];
}) {
  if (!currentRetweet) {
    return [];
  }

  const currentRetweetMediaItems = media.filter((mediaItem) =>
    currentRetweet.attachments?.media_keys?.includes(mediaItem.media_key)
  );

  const withMedia =
    currentRetweet.attachments?.media_keys.length &&
    currentRetweetMediaItems?.length;

  if (withMedia) {
    return currentRetweetMediaItems;
  }

  const currentMedia = currentRetweet.entities?.urls?.find(
    (url) => url.media_key === currentRetweet.attachments?.media_keys[0]
  );
  const type = currentMedia?.expanded_url.includes('video') ? 'video' : 'photo';
  const previewLink = `${TWITTER_CDN}?id=${currentRetweet.id}&token=${getToken(
    currentRetweet.id
  )}`;

  return [
    {
      type,
      media_key: currentRetweet.attachments?.media_keys[0],
      url: previewLink,
      preview_image_url: previewLink,
      is_preview_link: true
    }
  ];
}
